import classNames from 'classnames';
import * as React from 'react';

import { BlockSectionClassResolver } from '../../BlockSection/BlockSectionClassResolver';
import { withPromotionImpression } from '../../Tracking/GoogleTagManager/PromotionImpression/WithPromotionImpression';
import { TextColor } from '../TextColor.csharp';
import { TextBannerBackgroundVariant } from './TextBannerBackgroundVariant.csharp';
import { TextBannerProps } from './TextBannerProps.csharp';

function TextBanner(props: TextBannerProps) {
    const { model, backgroundImageCssClassDesktop, backgroundImageCssClassMobile } = props;

    const textBannerClassNames = classNames(
        'TextBanner',
        BlockSectionClassResolver.Resolve(model.blockSectionMargin),
        `TextBanner--Background${TextBannerBackgroundVariant[model.backgroundVariant]}`,
        `TextBanner--Text${TextColor[model.textColor]}`,
        (!model.link || model.hideLinkArrow) && 'TextBanner--NoLink'
    );

    const renderContent = (contentClassName: string, imageClassName: string) => {
        return (
            <div className={classNames('TextBanner__Content', contentClassName)}>
                {model.image != null && (
                    <div className="TextBanner__ImageBackground">
                        <div className={classNames('TextBanner__Image', imageClassName)} />
                    </div>
                )}
                <div className="TextBanner__Label">{model.label}</div>
                <div className="TextBanner__Heading">
                    <span>{model.heading}</span>
                </div>
            </div>
        );
    };

    return (
        <a className={textBannerClassNames} href={model.link} target={model.openInNewTab ? '_blank' : '_self'} rel="noreferrer">
            <div className="TextBanner__Inner">
                {renderContent('TextBanner__Content--Mobile', backgroundImageCssClassMobile)}
                {renderContent('TextBanner__Content--Desktop', backgroundImageCssClassDesktop)}
            </div>
        </a>
    );
}

export default withPromotionImpression(TextBanner);
